import React, { useEffect, useState } from "react";
import axios from "axios";
import LeadCaptureForm from "../components/LeadCaptureForm";
import { getReferrer, isFromSpecificSite } from "../utils/referrer";
import "./DynamicPage.css"; // Import the corresponding CSS

const DynamicPage = () => {
  const [funeralHome, setFuneralHome] = useState(null);
  const [funeralHomeName, setFuneralHomeName] = useState(null);
  const [acctId, setAcctId] = useState(null);
  const [fhCode, setFhCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [logoClass, setLogoClass] = useState("header-logos-dynamic");
  const [nameClass, setNameClass] = useState("hide");
  const [referrer, setReferrer] = useState(null);

  const logoURL = process.env.REACT_APP_LOGO_PATH;

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  let redirectToFallback = (
    <div className="page-container">
    <section className="header-section">
      <div className="header-logos">
        <img className="header-logos-static" alt="" src="//images.squarespace-cdn.com/content/v1/63d4149ecd36522e21bbb8c6/851f4ff3-ab5f-413a-9538-abc08ae02819/Group+4.png?format=1500w"></img>
        <div className="header-cta">
        </div>
      </div>
    </section>
    <section className="info-section">
    <h2 className="info-header"><a href="http://weilkahnfh.localhost:3000/">We're sorry, but you seem to be trying to go to a page that doesn't exist</a></h2>
    <p className="info-text">
      For Grief partners with local funeral homes to connect you to grief support events, information and courses that help you get what you need to navigate the loss of a loved one – or provide support for someone who has.
      <br />
      <br />
      If you feel you've reached this page in error, please email our customer support team using the button below.
    </p>
    <button className="hero-btn" onClick={sendEmail}>Email Support</button>
  </section>
  </div>
  );

  const Modal = ({ onClose, children }) => {
    return (
      <div className="overlay">
        <div className="modal">
          {children}
          <button onClick={onClose} className="closeButton">
            ×
          </button>
        </div>
      </div>
    );
  };

  const getSubdomain = () => {
    const hostname = window.location.hostname; // e.g., "subdomain.example.com"
    const parts = hostname.split(".");
    if (parts.length > 1) {
      return parts[0]; // Return the subdomain (e.g., "subdomain")
    }
    return ""; // Return empty if no subdomain exists
  };

  const getAPIUrl = () => {
    return process.env.REACT_APP_API_URL;
  };

  const subdomain = getSubdomain();
  const logoPathPng = `${logoURL}/${funeralHomeName}-${acctId}.png`;
  const logoPathJpg = `${logoURL}/${funeralHomeName}-${acctId}.jpg`;
  const logoPathJpeg = `${logoURL}/${funeralHomeName}-${acctId}.jpeg`;


  useEffect(() => {
    const sub = getSubdomain();
    const backendUrl = getAPIUrl();
    const referrer = getReferrer();
    setReferrer(referrer);

    const fetchFuneralHomeData = async () => {
      try {
        const response = await axios.get(
          `${backendUrl}/getdata?subdomain=${sub}`
        );
        if (response.status === 200 && response.data) {
          setFuneralHome(response.data.fhDisplayName);
          setFuneralHomeName(response.data.fhName);
          setAcctId(response.data.acctId);
          setFhCode(response.data.fhCode);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchFuneralHomeData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!funeralHome) {
    return redirectToFallback;
  }

  function sendEmail() {
    const email = "hello@elevia.com";
    const subject = `ForGrief Landing Page: ${window.location.hostname}`;
  
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  }

  function tryJpg(e) {
    e.target.src = logoPathJpg;
    e.target.onerror = () => tryJpeg(e);
  }

  function tryJpeg(e) {
    e.target.src = logoPathJpeg;
    e.target.onerror = () => showName();
  }

  function showName() {
    setLogoClass("hide");
    setNameClass("header-funeral-home-name");
  }


  return (

    <div className="page-container">
      {/* Hero Section */}
      <section className="header-section">
        <div className="header-logos">
          <img className="header-logos-static" alt="" src="//images.squarespace-cdn.com/content/v1/63d4149ecd36522e21bbb8c6/851f4ff3-ab5f-413a-9538-abc08ae02819/Group+4.png?format=1500w"></img>
          <img className={logoClass} src={logoPathPng} alt={`${subdomain} Logo`} onError={(e) => tryJpg(e)}></img>
          <p className={nameClass}>{funeralHome}</p>
          <div className="header-cta">
            <button className="header-btn" onClick={openModal}>Sign Up For Free!</button>
          </div>
        </div>
      </section>
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-header">A New Vision For Grief Support Resources</h1>
          <p className="hero-text">
            Grief is a personal experience, but you don't have to navigate it
            alone. <strong>{funeralHome}</strong> has partnered with For Grief to
            offer you direct access to leading grief experts, plus a library of
            videos and other resources that provide the support you need, when
            you need it. We're on this journey together. Sign up today.
          </p>
          <button className="hero-btn" onClick={openModal}>Sign Up</button>
        </div>
        <div className="hero-image">
          <img src="https://v.fastcdn.co/u/71d0526c/65250577-0-FG-homepage-hero.png" alt="Hero" />
        </div>

      </section>

      {/* For Grief Section */}
      <section className="info-section">
        <h2 className="info-header">For Grief. For You.</h2>
        <p className="info-text">
          For Grief is a resource that connects you to grief support events, information and courses that help you get what you need to navigate the loss of a loved one – or provide support for someone who has. We know from experience how difficult it can be to find comfort, insights and connections that are relevant to your needs. That's why we founded For Grief – and why we're so passionate about continuing to grow as circle of support like no other.
        </p>
      </section>

      {/* What We Offer Section */}
      <section className="offer-section">
        <h2 className="offer-header">What We Offer</h2>

        <p className="offer-text">
          These are just a few of the many resources For Grief provides to support people who have lost a loved one. We encourage you to sign up (for free!) to explore these and the many other resources we have created for you.
        </p>
        <div className="offer-grid-2">
          <div className="offer-item">
            <div className="offer-item-2-header"><span className="custom-underline">New </span> Grief Chats</div>
            <div className="offer-item-2-text">Our new collection of brief, compassionate conversations with grief professionals features a variety of topics to help you carry forward.</div>

          </div>
          <div className="offer-item">
            <img src="https://v.fastcdn.co/u/71d0526c/65252454-0-Screenshot-2024-09-0.png" alt="Grief Chats" />

          </div>
        </div>
        <div className="offer-grid">
          <div className="offer-item">
            <img src="https://v.fastcdn.co/u/71d0526c/65252481-0-for-grief-resources-.jpg" alt="Grief Calendar" />
            <div className="offer-item-header">Exclusive GriefCalendar™</div>
            <p>For Grief offers unprecedented access to special events presented by some of the most prominent experts in grief support.</p>

            <p>Visit our calendar to learn about upcoming opportunities.</p>
          </div>
          <div className="offer-item">
            <img src="https://v.fastcdn.co/u/71d0526c/65252480-0-for-grief-resources-.jpg" alt="Guides" />
            <div className="offer-item-header">Downloadable Guides</div>
            <p>There are many misconceptions about grief, and specific situations that require more insights and information. We've provided several free guides to help you through these scenarios.</p>
          </div>
          <div className="offer-item">
            <img src="https://v.fastcdn.co/u/71d0526c/65252491-0-for-grief-resources-.jpg" alt="Support Library" />
            <div className="offer-item-header">Grief Support Library</div>
            <p>The For Grief team has compiled a list of the books that can help address the needs of people who are experiencing grief in many different circumstances.</p>
          </div>
          <div className="offer-item">
            <img src="https://v.fastcdn.co/u/71d0526c/65252457-0-for-grief-resources-.jpg" alt="Community Support" />
            <div className="offer-item-header">Community Support</div>
            <p>
              We understand that everyone grieves differently, and may require different levels of support. Here you can access courses and communities from grief professionals who, like For Grief, are committed to supporting your unique needs.
            </p>
          </div>
          <div className="offer-item">
            <img src="https://v.fastcdn.co/u/71d0526c/65252458-0-for-grief-resources-.jpg" alt="Community Support" />
            <div className="offer-item-header">For Grief Facebook Community</div>
            <p>We've created a private Facebook group where you can share your stories and learn from the experiences of others. We're here to support you.</p>
          </div>
          <div className="offer-item">
            <img src="https://v.fastcdn.co/u/71d0526c/65252456-0-for-grief-resources-.jpg" alt="Newsletter" />
            <div className="offer-item-header">Monthly Newsletter</div>
            <p>One of the best ways to get connected with For Grief resources is to subscribe to our free newsletter, Mourning Boost. Each month, we send out a freshly curated collection of our best articles, videos, upcoming events and much more.</p>
          </div>
        </div>
      </section>

      {/* Footer Call-to-Action */}
      <section className="cta-section">

        <div className="cta-image">
          <img src="https://v.fastcdn.co/u/71d0526c/65252479-0-OnlineSupportheader.png" alt="Hero" />
        </div>
        <div className="cta-content">
          <h2 className="cta-header">Sign up for support when you need it.</h2>

          <p className="cta-text">
            At <strong>{funeralHome}</strong>, we have partnered with For Grief to give
            you full access to all of their grief support resources at no cost.
            Sign up today for free and start navigating grief however you need it,
            whenever you need it.
          </p>

          <button className="cta-btn" onClick={openModal}>Sign Up For Free!</button>
        </div>

      </section>
      {/* Modal */}
      {isModalOpen && (
        <Modal onClose={closeModal}>
          <div className="modal-header">
            <p>Sign up for support when you need it.</p>
          </div>
          <div className="modal-content">
            <p className="modal-text">
              At <strong>{funeralHome}</strong>, we have partnered with For Grief to give
              you full access to all of their grief support resources at no cost.
              Sign up today for free and start navigating grief however you need it,
              whenever you need it.
            </p>
          </div>
          <div className="modal-section">
            <div className="domani-wrapper">
              <LeadCaptureForm 
                fhCode={fhCode}
                isFromSpecificSite={referrer ? isFromSpecificSite(referrer) : false}
                />
            </div>
          </div>
        </Modal>
      )}

    </div>

  );
};

export default DynamicPage;